const MAX_DOCUMENT_NAME_LENGTH = 50;
const EXTENSION_LENGTH = 4;

export { MAX_DOCUMENT_NAME_LENGTH, EXTENSION_LENGTH };
